import { Component, OnInit } from '@angular/core';
import { stateSubject } from 'src/helpers';
import { ScrollService } from '../../services/scroll.service';
import {
  faPeopleGroup,
  faSearch,
  faHome,
} from '@fortawesome/free-solid-svg-icons';
import { faCompass } from '@fortawesome/free-regular-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-navigation',
  templateUrl: './mobile-navigation.component.html',
  styleUrls: ['./mobile-navigation.component.scss'],
})
export class MobileNavigationComponent implements OnInit {
  navItems = [
    { Key: '', Icon: faHome },
    { Key: 'search', Icon: faSearch },
    { Key: 'explore', Icon: faCompass },
    { Key: 'followed', Icon: faPeopleGroup },
  ];
  activeItem = this.navItems[0];

  constructor(private router: Router, private scrollService: ScrollService) {}

  ngOnInit() {
    stateSubject.subscribe(({ state }) => {
      const updated = state === 'main' ? '' : state;
      this.activeItem = this.navItems.find((x) => x.Key === updated);
    });
  }

  navigate = (item, queryParams?: unknown) => {
    if (item.Key === '' && location.pathname.slice(1) == '') {
      this.scrollService.scrollToTopSubject.next(null);
    }
    this.activeItem = item;
    this.router.navigate([item.Key], {
      queryParams,
    });
  };
}
